export const avatarSx = { flexShrink: 0 };

export const descriptionWrapSx = {
  flexWrap: 'nowrap',
  flexDirection: 'column',
};

export const descriptionMobileWrapSx = {
  flexWrap: 'wrap',
  flexDirection: 'column',
};

export const multiSelectStyles = (isMobile: boolean) => ({
  height: '56px',
  borderRadius: '4px',
  opacity: 1,
  '.MuiSelect-select.MuiSelect-select': {
    height: '56px',
    overflowY: 'auto',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '6px 32px 6px 8px',
    boxSizing: 'border-box',
    '& > div': {
      margin: 0,
    },
  },
  '.MuiSvgIcon-root.MuiSelect-icon': {
    top: isMobile ? '12px' : '50%',
    transform: isMobile ? 'none' : 'translateY(-50%)',
  },
});
